export const WELCOME_MESSAGE_PATTERN = /^\s*benvenut[oa]\b/i;

export const MINUTE_MS = 60 * 1000;
export const SKELETON_DELAY_RESET_MS = 1000;
